import {
  Button,
  ButtonProps,
  Dialog,
  ThemeProvider,
  styled,
} from "@mui/material";
import "./ConfirmationPopup.scss";
import { theme } from "../../utils/constants";
import images from "../../assets/images";
import { getScreenDimensions } from "../../utils/helper";

interface propsType {
  open: boolean;
  message: string;
  gifData?: string;
  deleteForMeButtonFunctionality?: () => void;
  yesButtonFunctionality: () => void;
  noButtonFunctionality?: () => void;
  messageWidth: string;
  page?: string;
  isForceUpdate?: boolean
}

interface StyledButtonProps extends ButtonProps {
  width?: string;
  variant?: "contained";
}

// Yes Button Style
const YesStyledButton = styled(Button)<StyledButtonProps>(() => ({
  fontFamily: "var(--font-inter)",
  fontSize: "12px",
  fontWeight: 700,
  cursor: "pointer",
  border: "0",
  backgroundColor: "var(--color-steelblue)",
  borderRadius: "20px",
  height: "31px",
  width: "85px",
  display: "flex",
  color: "#ffffff",
  alignItems: "center",
  justifyContent: "center",
  boxSizing: "border-box",
  textTransform: "none",
  "&:hover": {
    backgroundColor: "var(--color-steelblue)",
    color: "#ffffff",
  },
}));

// delete for me and delete for everyone Button Style
const DeleteStyledButton = styled(Button)<StyledButtonProps>(() => ({
  fontFamily: "var(--font-inter)",
  fontSize: "12px",
  fontWeight: 700,
  cursor: "pointer",
  border: "0",
  backgroundColor: "var(--color-steelblue)",
  borderRadius: "20px",
  height: "31px",
  width: "160px",
  lineHeight: "12px",
  display: "flex",
  color: "#ffffff",
  alignItems: "center",
  justifyContent: "center",
  boxSizing: "border-box",
  textTransform: "none",
  "&:hover": {
    backgroundColor: "var(--color-steelblue)",
    color: "#ffffff",
  },
}));

// No Button Style
const NoStyledButton = styled(Button)<StyledButtonProps>(() => ({
  fontFamily: "var(--font-inter)",
  fontSize: "12px",
  fontWeight: 700,
  cursor: "pointer",
  border: "0",
  backgroundColor: "#F3F7FA",
  borderRadius: "20px",
  height: "31px",
  width: "84px",
  display: "flex",
  color: "#000000",
  alignItems: "center",
  justifyContent: "center",
  boxSizing: "border-box",
  textTransform: "none",
  "&:hover": {
    backgroundColor: "#F3F7FA",
    color: "#000000",
  },
}));

// Cancel Button Style
const CancelStyledButton = styled(Button)<StyledButtonProps>(() => ({
  fontFamily: "var(--font-inter)",
  fontSize: "12px",
  fontWeight: 700,
  cursor: "pointer",
  border: "0",
  backgroundColor: "#F3F7FA",
  borderRadius: "20px",
  height: "31px",
  width: "160px",
  display: "flex",
  color: "#000000",
  alignItems: "center",
  justifyContent: "center",
  boxSizing: "border-box",
  textTransform: "none",
  "&:hover": {
    backgroundColor: "#F3F7FA",
    color: "#000000",
  },
}));

const ConfirmationPopup = ({
  open,
  message,
  gifData,
  messageWidth,
  deleteForMeButtonFunctionality,
  yesButtonFunctionality,
  noButtonFunctionality,
  page,
  isForceUpdate
}: propsType) => {
  const { closeIcon } = images;
  const { isMobileScreen } = getScreenDimensions();

  return (
    <ThemeProvider theme={theme}>
      <Dialog open={open} classes={{ paper: "paperStyle" }}>
        <div
          className={
            page === "chat" ? "chatdialogMainContainer" : page === "forgotpassword" && isMobileScreen ? "fortgoutPasswordContainer" :"dialogMainContainer"
          }
        >
          {(page === "logout" || page === "forgotpassword") && <img src={closeIcon} className="closeIcon" onClick={noButtonFunctionality} />}
          {(page !== 'selectVirtualProgram') && gifData && <img src={gifData} alt="logoutGif" className="logoutGif" />}
          <div className="messageStyle" style={{ width: messageWidth, marginTop: page === 'selectVirtualProgram' ? '30px': '' }}>
            {message}
          </div>
          <div className={page === "chat" ? "chatCtaActions" : "ctaActions"} style={{marginTop: page === 'selectVirtualProgram' ? '30px' : ''}}>
            {page === "chat" ? (
              <>
                <DeleteStyledButton
                  variant="contained"
                  className="yesBtnStyle"
                  disableElevation
                  onClick={deleteForMeButtonFunctionality}
                >
                  Delete for me
                </DeleteStyledButton>
                <DeleteStyledButton
                  variant="contained"
                  className="yesBtnStyle"
                  disableElevation
                  onClick={yesButtonFunctionality}
                >
                  Delete for everyone
                </DeleteStyledButton>
                <CancelStyledButton
                  variant="contained"
                  className="noBtnStyle"
                  disableElevation
                  onClick={noButtonFunctionality}
                >
                  Cancel
                </CancelStyledButton>
              </>
            ) : 
            page === "AppUpdate" ? (
              <>
              <YesStyledButton
                  variant="contained"
                  className="yesBtnStyle"
                  disableElevation
                  onClick={yesButtonFunctionality}
                >
                  Update
                </YesStyledButton>
                {!isForceUpdate && <NoStyledButton
                  variant="contained"
                  className="noBtnStyle"
                  disableElevation
                  onClick={noButtonFunctionality}
                >
                  Skip
                </NoStyledButton>}
              </>
            ) :
            page === "forgotpassword" ? (
              <YesStyledButton
                variant="contained"
                className="yesBtnStyle"
                disableElevation
                onClick={yesButtonFunctionality}
              >
                Ok
              </YesStyledButton>
            ) : (
              <>
                <YesStyledButton
                  variant="contained"
                  className="yesBtnStyle"
                  disableElevation
                  onClick={yesButtonFunctionality}
                >
                  Yes
                </YesStyledButton>
                <NoStyledButton
                  variant="contained"
                  className="noBtnStyle"
                  disableElevation
                  onClick={noButtonFunctionality}
                >
                  No
                </NoStyledButton>
              </>
            )}
          </div>
        </div>
      </Dialog>
    </ThemeProvider>
  );
};

export default ConfirmationPopup;
